import {Component, HostBinding, inject, input, OnInit} from '@angular/core';
import {StoryblokService} from '@core/services/storyblok.service';
import {StoryblokStylingService} from '@core/services/storyblok-styling.service';
import {RoutingService} from '@core/services/routing.service';
import {DynamicModule} from 'ng-dynamic-component';
import {AsyncPipe, NgComponentOutlet} from '@angular/common';
import {ModalContainerComponent} from '../modal-container/modal-container.component';
import {StoryblokComponentService} from '@core/services/storyblok-component.service';
import {from, Observable} from 'rxjs';
import {tap} from 'rxjs/operators';

@Component({
  selector: 'app-basic-page-modal',
  templateUrl: './basic-page-modal.component.html',
  styleUrls: ['./basic-page-modal.component.scss'],
  imports: [DynamicModule, AsyncPipe, NgComponentOutlet, ModalContainerComponent]
})
export class BasicPageModalComponent implements OnInit {
  protected routingService = inject(RoutingService);
  protected storyblokComponentService = inject(StoryblokComponentService);
  private storyblokService = inject(StoryblokService);
  private storyblokStylingService = inject(StoryblokStylingService);


  basicPage$: Observable<any>;

  readonly general_styling = input<any>();
  @HostBinding('class') class: any;

  private _path: string;
  private anchor: string;

  get path(): string {
    return this._path;
  }

  set path(value: string) {
    const hasChanged = value !== this.path;
    this._path = value;
    if (hasChanged) {
      this.basicPage$ = from(this.getBasicPageStoryblok(this.path)).pipe(
        tap(() => {
          if (this.anchor) {
            setTimeout(() => {
              document.querySelector('#' + this.anchor)?.scrollIntoView();
            });
          }
        })
      );
    }
  }

  components: any;

  constructor() {
    const storyblokComponentService = this.storyblokComponentService;

    this.components = storyblokComponentService.getComponents();
  }

  ngOnInit(): void {
    this.class = this.storyblokStylingService.getClassList(this.general_styling());
  }

  protected getBasicPageStoryblok(path: any) {
    return this.storyblokService.getStoryPromise(path, this.routingService.getQueryParams());
  }
}
